
import { Fraga } from "@/types/riskbedomning";

export const electricalRiskFragor: Fraga[] = [
  {
    id: "hogspanning",
    text: "Finns det risk att arbete sker nära högspänningsledningar?",
    kategori: "Särskilda arbetsmiljörisker",
    fas: "byggskede",
    followUpQuestions: [
      "Finns det risk att säkerhetsavstånd mellan arbete och högspänningsledning saknas?",
      "Finns det risk att strömmen inte kan brytas tillfälligt under arbetet?",
      "Finns det risk att fordon eller lyftkranar kommer för nära elledningarna?"
    ]
  }
];
